import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { cryodeckApi } from "@/api/cryodeck";

export function useCryodeckBottles(deviceId: string, unlocatedOnly = false) {
  return useQuery({
    queryKey: ["device", deviceId, "cryodeck-bottles", unlocatedOnly],
    queryFn: () => cryodeckApi.list(deviceId, unlocatedOnly),
    enabled: !!deviceId,
  });
}

export function useSetBottleLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ bottleId, location }: { bottleId: number; location: string | null }) =>
      cryodeckApi.setLocation(bottleId, location),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["device"], type: "active" });
    },
  });
}
